import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJUsageDetail from '../view/FJUsageDetail.jsx';
import { useSelector } from 'react-redux';

const FJUsageDetailContainer = () => {
    useLocalStore();
    const currentQuality = useSelector(state => state.AIVideoGenerator.currentQuality);
    const currentDuration = useSelector(state => state.AIVideoGenerator.currentDuration);
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);
    return <FJUsageDetail currentQuality={currentQuality} currentDuration={currentDuration} tabIndex={tabIndex} />;
};

export default FJUsageDetailContainer;
